import { useLazyQuery } from '@apollo/client'

import { APIStatus } from '@flowwai-frontend/shared/api-common'
import {
   convertToErrorType,
   getAPIStatusFromNetworkStatus,
   CustomError
} from '@flowwai-frontend/bps-officer-web/common/data-access'

import {
   GetContactTemplateQueryVariables as QueryVariables,
   GetContactTemplateQuery as Query,
   GetContactTemplateDocument as QueryDocument
} from './query.generatedTypes'
import useAPIResponseHandler from './responseHandler'

export interface FailureArgsType {
   error?: Error | null
   data?: CustomError<Query['getUserAppConfig']>
}

interface TriggerAPIArgsType {
   onFailure?: (args: FailureArgsType) => void
   onSuccess?: () => void
}

interface ReturnType {
   apiError: Error | null
   apiStatus: APIStatus

   triggerAPI: (args: TriggerAPIArgsType) => void
}

const useGetContactTemplate = (): ReturnType => {
   const [getAccount, { error, networkStatus, data }] = useLazyQuery<
      Query,
      QueryVariables
   >(QueryDocument)

   const { handleAPIResponse } = useAPIResponseHandler()

   const triggerAPI = async (args: TriggerAPIArgsType): Promise<void> => {
      const response = await getAccount({
         variables: {},

         onError(error) {
            args.onFailure?.({ error })
         }
      })
      if (!response.data) return

      handleAPIResponse({
         data: response.data,

         onHandleError: (
            errorMessage: string,
            data: Query['getUserAppConfig']
         ) => args.onFailure?.({ data: new CustomError(errorMessage, data) }),
         onSuccess: args.onSuccess
      })
   }

   const apiError = convertToErrorType(error)
   const apiStatus = getAPIStatusFromNetworkStatus(networkStatus, data)

   return {
      apiError,
      apiStatus,

      triggerAPI
   }
}

export default useGetContactTemplate
